module.exports = __webpack_public_path__ + "static/media/highlevel.add7ae97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/highlevel.svg
// module id = 432
// module chunks = 0